import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import {
    ActionsRow,
    FixedDropDownButton,
    Icon,
    modal,
    utils,
    Loader,
    commons
} from "@mc/mc-legacy";
import {Button, ButtonToolbar, Card, CardBody, CardHeader, Col, DropdownItem, Row} from "reactstrap";
const {sinkEvent} = commons;
import {withRouter} from "react-router";
import * as opravneniActions from "../actions/opravneniActions";
import * as subjektActions from "../actions/subjektActions";
import SpolecnostPobockaVydejForm from "../forms/SpolecnostPobockaVydejForm";
import SubjektApi from "../api/gen/cgo/SubjektApi";
import * as ciselnikActions from "../actions/ciselnikActions";
import {Component} from "react";
import * as React from "react";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Panel zobrazující výdejní pobočky společnosti.
 */
class SpolecnostPobockyVydejPanel extends Component<WithTranslation> {

    static propTypes = {
        spolecnostPobockyVydejList: PropTypes.array.isRequired, // seznam výdejních poboček
        spolecnost: PropTypes.object.isRequired, // VO společnosti ke které výdejní pobočka patří
        readOnly: PropTypes.bool, // zda bude panel read only, tj. nebudou zobrazeny editační akce, implicitně true
    };

    static defaultProps = {
        readOnly: true,
    };

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(ciselnikActions.fetchPobockyNevydejniIfNeeded());
        this.props.dispatch(opravneniActions.fetchLoggedInUserIfNeeded());
    };

    handleCreateSpolecnostPobockaVydej = () => {
        const {spolecnost, t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            SpolecnostPobockaVydejForm,
            {
                onSubmit: (data) => {
                    return SubjektApi.createVydejPobockaSpolecnosti(spolecnost.id, data.pobockaId);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(subjektActions.invalidateSpolecnostPobockaVydej());
                    dispatch(subjektActions.invalidateSpolecnostPobockaVydejVcetneVydejni());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                getPobockaName: this.getPobockaName,
            },
            t('private_dispensing_branch.new'),
            {size: "md"}
        ));
    };

    handleDeleteSpolecnostPobockaVydej = (spolecnostPobockaVydej) => {
        const {spolecnost, t} = this.props;
        this.props.dispatch(
            modal.ModalActions.showConfirm(
                t('private_dispensing_branch.delete'),
                t('private_dispensing_branch.delete_confirm', {branch: <b>{spolecnostPobockaVydej.nazevPobocka}, {spolecnostPobockaVydej.ulice} {spolecnostPobockaVydej.psc}</b>}),
                () => {
                    SubjektApi.deleteVydejPobockaSpolecnosti(spolecnost.id, spolecnostPobockaVydej.id).then(() => {
                        this.props.dispatch(subjektActions.invalidateSpolecnostPobockaVydej());
                        this.props.dispatch(subjektActions.invalidateSpolecnostPobockaVydejVcetneVydejni());
                    });
                },
                null,
                t('private_dispensing_branch.discard')
            )
        );
    };

    renderActions = () => {
        const {readOnly, t} = this.props;
        return <ButtonToolbar>
            {!readOnly && <Button onClick={this.handleCreateSpolecnostPobockaVydej}>{t('new_n')}</Button>}
        </ButtonToolbar>
    };

    getPobockaName = (spolecnostPobockaVydej) => {
        return `${spolecnostPobockaVydej.nazevPobocka + (spolecnostPobockaVydej.ulice || spolecnostPobockaVydej.psc ? ', ' + spolecnostPobockaVydej.ulice + (spolecnostPobockaVydej.psc ? ' ' + spolecnostPobockaVydej.psc : '') : '')}`;
    };

    renderContextMenu = (spolecnostPobockaVydej) => {
        const {t} = this.props;
        return <FixedDropDownButton color="action action-hover" noCaret title={<Icon icon="ellipsis-v" />}>
            <DropdownItem key="2" onClick={sinkEvent(this.handleDeleteSpolecnostPobockaVydej.bind(this, spolecnostPobockaVydej))}>{t('private_dispensing_branch.discard')}</DropdownItem>
        </FixedDropDownButton>
    };

    render() {
        const {loggedInUser, spolecnostPobockyVydejList, readOnly, pobockyNevydejniList, t} = this.props;

        if (!loggedInUser.fetched || !pobockyNevydejniList.fetched) {
            return <Loader />;
        }

        return <Card className="pobocky-vydej-panel">
            <CardHeader>
                <ActionsRow actions={!readOnly ? this.renderActions() : null}>
                    <h2>{t('private_dispensing_branch.many')}</h2>
                </ActionsRow>
            </CardHeader>
            <div className="items-list">
                {spolecnostPobockyVydejList.length > 0 ? spolecnostPobockyVydejList.map(spolecnostPobockaVydej =>
                    <CardBody key={spolecnostPobockaVydej.id}>
                        <ActionsRow actions={!readOnly ? this.renderContextMenu(spolecnostPobockaVydej) : null}>
                            <Row>
                                <Col>
                                    {this.getPobockaName(spolecnostPobockaVydej)}
                                </Col>
                            </Row>
                        </ActionsRow>
                    </CardBody>
                ) : <CardBody><i>{t('private_dispensing_branch.none')}</i></CardBody>}
            </div>
        </Card>
    }
}

function mapStateToProps(state) {
    return {
        pobockyNevydejniList: utils.storeFromArea(state, ciselnikActions.POBOCKY_NEVYDEJNI_LIST_AREA),
        loggedInUser: utils.storeFromArea(state, opravneniActions.LOGGED_IN_USER_AREA),
    }
}

export default withRouter(connect(mapStateToProps)(withTranslation()(SpolecnostPobockyVydejPanel)));
